module.exports = __webpack_public_path__ + "img/业务员设置.cd2b26d7.svg";